// ##### 25-01-10 Komarov
import axios from 'axios';
import { getUrl } from '../../helpers/crypto';
import {
  FETCH_GALLERY_BEGIN,
  FETCH_GALLERY_FAILURE,
  FETCH_GALLERY_SUCCESS,
} from '../constants';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../server/helpers/uniLog';

const fetchGalleryBegin = () => ({
  type: FETCH_GALLERY_BEGIN,
});

const fetchGallerySuccess = galleryData => ({
  type: FETCH_GALLERY_SUCCESS,
  payload: { galleryData },
});

const fetchGalleryFailure = error => ({
  type: FETCH_GALLERY_FAILURE,
  payload: { error },
});
// ##### 25-04-21 Komarov
export function fetchGallery(spid, lang, deviceType) {
  // ##### 25-01-10 Komarov
  const url = getUrl(
    'sitepagecontent',
    `id=${spid}&language=${lang}&deviceType=${deviceType}`
  );
  // ##### Komarov 2025-09-02
  uniLog(
    'gallery.js',
    'axios:src/Redux/actions/gallery.js:fetchGallery, url:',
    url
  );
  // ##### 24-09-12 Komarov: Сделал функцию асинхронной, чтобы дожидаться получения ответа на fetch-запрос
  return async dispatch => {
    dispatch(fetchGalleryBegin());
    try {
      const response = await axios.get(url);
      dispatch(fetchGallerySuccess(response.data));
    } catch (error) {
      return dispatch(fetchGalleryFailure(error));
    }
  };
}
